import React from 'react';
import { authPostRequest } from '../services/api-service';
import { getAllUsersByRoleUrl } from '../seed/url';
import { SMAIVENDOR } from '../utils/constant';
import { getUserDisplayName } from './use-staff-users';

export function useVendors() {
  const [vendors, setVendors] = React.useState([]);
  const [isLoadingVendors, setIsLoadingVendors] = React.useState(true);

  React.useEffect(() => {
    let isMounted = true;

    setIsLoadingVendors(true);
    authPostRequest(
      getAllUsersByRoleUrl,
      {
        role: SMAIVENDOR,
        sort: 'id desc',
        limit: 100,
        page: 1,
      },
      (data) => {
        if (!isMounted) {
          return;
        }

        setVendors(
          (data?.results || [])
            .map((vendor) => ({
              ...vendor,
              userName: getUserDisplayName(vendor),
            }))
            .sort((a, b) => a.userName.localeCompare(b.userName)),
        );
        setIsLoadingVendors(false);
      },
      () => {
        if (!isMounted) {
          return;
        }

        setVendors([]);
        setIsLoadingVendors(false);
      },
    );

    return () => {
      isMounted = false;
    };
  }, []);

  return { vendors, isLoadingVendors };
}
